export enum EValidationRegex {
  None = '',
  Address = '[a-zA-Z\\d\\s\\-\\,\\#\\.\\+]+',
  Phone = '^\\s*(?:\\+?(\\d{1,3}))?([-. (]*(\\d{3})[-. )]*)?((\\d{3})[-. ]*(\\d{2,4})(?:[-.x ]*(\\d+))?)\\s*$',
  Email = '[a-zA-Z0-9_\\.\\+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-\\.]+',
  UsDate = '((0[1-9])|(1[0-2]))[\\/-]((0[1-9])|(1[0-9])|(2[0-9])|(3[0-1]))[\\/-](\\d{4})',
  SeDate = '^\\d{4}\\-(0?[1-9]|1[012])\\-(0?[1-9]|[12][0-9]|3[01])$',
  Numbers = '^[\\d\\s]+$',
  UsPhone = '^(?:\\(\\d{3}\\)|\\d{3})(?: *- *)?\\d{3}(?: *- *)?\\d{4}$',
  Website = '^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$',
  ZipCode = '^([0-9]{5}(?:-[0-9]{4})?)*$',
  UsState = '^(?:A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|PA|RI|S[CD]|T[NX]|UT|V[AT]|W[AIVY])*$',
  UsSsnCaSin = '^(\\d{3}-\\d{3}-\\d{3})|(\\d{3}-\\d{2}-\\d{4})$',
  Custom = '[\\s\\S]*',
}
